var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.mapInitialized
    ? _c(
        "div",
        {
          staticClass:
            "panel-layers ct-aside-control ct-aside-left ct-aside-control-light",
          class: { "ct-aside-control-slide-open": _vm.showModal },
          attrs: { "data-panel": _vm.idPanel },
        },
        [
          _c("div", { staticClass: "ct-aside-control-actions" }, [
            _c(
              "button",
              {
                staticClass: "close position-absolute pos-top pos-right",
                attrs: {
                  type: "button",
                  title: "Fechar",
                  "data-dismiss": "modal",
                  "aria-label": "Close",
                },
                on: {
                  click: function ($event) {
                    return _vm.closeModal(_vm.idPanel)
                  },
                },
              },
              [
                _c("span", { attrs: { "aria-hidden": "true" } }, [
                  _c(
                    "svg",
                    {
                      staticClass: "svg-inline--fa fa-times fa-w-13",
                      attrs: {
                        "aria-hidden": "true",
                        focusable: "false",
                        "data-prefix": "fas",
                        "data-icon": "times",
                        role: "img",
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 320 512",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          fill: "currentColor",
                          d: "M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z",
                        },
                      }),
                    ]
                  ),
                ]),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "ct-aside-control-content h-100" }, [
            _vm.enableToolFilterStatus
              ? _c(
                  "div",
                  { staticClass: "ct-aside-control-item accordion d-sm-none" },
                  [
                    _vm.enableToolFilterStatus
                      ? _c("map-filter-status-control", {
                          attrs: {
                            moduleCode: _vm.moduleCode,
                            aside: true,
                            asideExpanded: true,
                            asideCss: "card",
                            asideCssHeader: "ct-aside-control-header",
                            asideCssBody:
                              "ct-aside-control-body collapse-transition",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.enableToolFilterTypes
              ? _c(
                  "div",
                  { staticClass: "ct-aside-control-item accordion d-sm-none" },
                  [
                    _vm.enableToolFilterTypes
                      ? _c("map-filter-types-control", {
                          attrs: {
                            moduleCode: _vm.moduleCode,
                            aside: true,
                            asideExpanded: false,
                            asideCss: "card",
                            asideCssHeader: "ct-aside-control-header",
                            asideCssBody:
                              "ct-aside-control-body collapse-transition",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.enableToolMapLayers
              ? _c(
                  "div",
                  { staticClass: "ct-aside-control-item accordion h-100" },
                  [
                    _c("div", { staticClass: "card h-100" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "ct-aside-control-header d-flex flex-column mb-2",
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "w-100 mb-3",
                              attrs: {
                                "aria-controls": "#map-layers",
                                href: "#map-layers",
                                "data-toggle": "collapse",
                                role: "button",
                                "aria-expanded": _vm.expanded.layers,
                              },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.toggle("layers")
                                },
                              },
                            },
                            [
                              _c("div", { staticClass: "title" }, [
                                _vm._v(
                                  "\n                            Camadas do mapa\n                            "
                                ),
                                _vm.expanded.active
                                  ? _c("span", {
                                      staticClass: "right icon-collapse svg",
                                      class: { show: _vm.expanded.layers },
                                    })
                                  : _vm._e(),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "w-100 form-inline" }, [
                            _c(
                              "div",
                              {
                                staticClass: "input-group sidebar-search w-100",
                                attrs: { "data-widget": "sidebar-search" },
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.inputLayer,
                                      expression: "inputLayer",
                                    },
                                  ],
                                  staticClass:
                                    "form-control py-2 shadow-none border-right-0 border",
                                  attrs: {
                                    type: "search",
                                    placeholder: "Pesquise...",
                                    "aria-label": "Search",
                                  },
                                  domProps: { value: _vm.inputLayer },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.inputLayer = $event.target.value
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _vm._m(0),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "w-100 form-inline" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "input-group sidebar-actions-layer w-100",
                                attrs: {
                                  "data-widget": "sidebar-actions-layer",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "btn-toolbar w-100 justify-content-center",
                                    attrs: {
                                      role: "toolbar",
                                      "aria-label": "",
                                    },
                                  },
                                  [
                                    _vm.isLayerSelected
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "btn-group btn-block",
                                            attrs: {
                                              role: "group",
                                              "aria-label": "Layer Actions",
                                            },
                                          },
                                          _vm._l(
                                            _vm.filteredLayerActions,
                                            function (layerAction) {
                                              return _c(
                                                "button",
                                                {
                                                  key: `layer-${layerAction.id}`,
                                                  staticClass:
                                                    "btn btn-main min-w-auto action-layer",
                                                  attrs: {
                                                    title: layerAction.title,
                                                    type: "button",
                                                    "data-toggle":
                                                      "tooltip-city",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      $event.preventDefault()
                                                      return _vm.applyAction(
                                                        layerAction,
                                                        $event
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  layerAction.icon
                                                    ? _c("i", {
                                                        class: layerAction.icon,
                                                      })
                                                    : layerAction.image
                                                    ? _c("span", {
                                                        domProps: {
                                                          innerHTML: _vm._s(
                                                            layerAction.image
                                                          ),
                                                        },
                                                      })
                                                    : _vm._e(),
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        )
                                      : _vm.isGroupSelected
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "btn-group",
                                            attrs: {
                                              role: "group",
                                              "aria-label": "Group Actions",
                                            },
                                          },
                                          _vm._l(
                                            _vm.filteredGroupActions,
                                            function (groupAction) {
                                              return _c(
                                                "button",
                                                {
                                                  key: `group-action-${groupAction.id}`,
                                                  staticClass:
                                                    "btn btn-main min-w-auto",
                                                  attrs: {
                                                    title: groupAction.title,
                                                    type: "button",
                                                    "data-toggle":
                                                      "tooltip-city",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      $event.preventDefault()
                                                      return _vm.applyAction(
                                                        groupAction,
                                                        $event
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  groupAction.icon
                                                    ? _c("i", {
                                                        class: groupAction.icon,
                                                      })
                                                    : groupAction.image
                                                    ? _c("span", {
                                                        domProps: {
                                                          innerHTML: _vm._s(
                                                            groupAction.image
                                                          ),
                                                        },
                                                      })
                                                    : _vm._e(),
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        )
                                      : _c(
                                          "div",
                                          {
                                            staticClass: "btn-group",
                                            attrs: {
                                              role: "group",
                                              "aria-label": "Global Actions",
                                            },
                                          },
                                          _vm._l(
                                            _vm.filteredGlobalActions,
                                            function (globalAction) {
                                              return _c(
                                                "button",
                                                {
                                                  key: `global-action-${globalAction.id}`,
                                                  staticClass:
                                                    "btn btn-main min-w-auto",
                                                  attrs: {
                                                    title: globalAction.title,
                                                    type: "button",
                                                    "data-toggle":
                                                      "tooltip-city",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      $event.preventDefault()
                                                      return _vm.applyAction(
                                                        globalAction,
                                                        $event
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  globalAction.icon
                                                    ? _c("i", {
                                                        class:
                                                          globalAction.icon,
                                                      })
                                                    : globalAction.image
                                                    ? _c("span", {
                                                        domProps: {
                                                          innerHTML: _vm._s(
                                                            globalAction.image
                                                          ),
                                                        },
                                                      })
                                                    : _vm._e(),
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                  ]
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "ct-aside-control-body p-0",
                          class: { show: _vm.expanded.layers },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "ct-aside-control-menu-wrapper flex-fill",
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "ct-aside-control-menu" },
                                [
                                  _c(
                                    "nav",
                                    {},
                                    [
                                      _vm.loaded
                                        ? _c("tree-layers", {
                                            ref: "layers-tree",
                                            staticClass:
                                              "ct-aside-control-menu-nav nav nav-pills nav-sidebar flex-column",
                                            attrs: {
                                              nodes: _vm.getLayers(),
                                              map: _vm.getMap(),
                                              nodeActions:
                                                _vm.enabledLayerGenericActions,
                                              activeSelect: _vm.enableTools,
                                            },
                                            on: {
                                              emitNodeSelected:
                                                _vm.onNodeSelected,
                                              emitNodeAdded: _vm.onNodeAdded,
                                              emitNodeAction: (
                                                action,
                                                node,
                                                evt
                                              ) =>
                                                this.applyAction(
                                                  action,
                                                  evt,
                                                  node
                                                ),
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]),
                  ]
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          !!_vm.exportLayerAction
            ? _c("layer-download", {
                ref: "modalLayerDownload",
                attrs: { url: _vm.urlLayerSelected, layer: _vm.selectedNode },
              })
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "input-group-append" }, [
      _c("div", { staticClass: "input-group-text bg-transparent" }, [
        _c("i", { staticClass: "fa fa-filter" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }